import React, {useContext} from 'react'
import Header  from './Header'
import SiteContext from "../context/SiteContext"

const IRSHeader = () => {

  const {site} = useContext(SiteContext)

  return (
    <Header 
      headerNavItems={site.headerNavItems} 
      mobileHeaderNavItems={site.mobileHeaderNavItems}
    />
  )
}

export default IRSHeader
